import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { serviceUris } from '../../../../environments/services';
import { Injectable, inject } from '@angular/core';
import { TransactionLogFilter } from '../models/transaction-log-filter.model';
import { PaginatedTransactionLogResponse } from '../models/paginated-transaction-log.model';

export interface TransactionTypeListResponse {
  data: Array<string>;
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class TransactionLogService {
  private http = inject(HttpClient);

  /**
   * Search transaction logs with filters and pagination
   * @param filters TransactionLogFilter
   * @param pageNumber page number
   * @param pageSize page size
   * @param localTimeZone local timezone string
   */
  searchTransactionLog(
    filters: TransactionLogFilter,
    pageNumber: number,
    pageSize: number,
    localTimeZone: string
  ): Observable<PaginatedTransactionLogResponse> {
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const params: any = {
      ...filteredParams,
      page: pageNumber,
      pageSize
    };
    const url = `${environment.backOfficeUrl}${serviceUris.searchTransactionLog}`;
    return this.http.get<PaginatedTransactionLogResponse>(url, { headers: { localTimeZone }, params: params });
  }

  /**
   * Fetches distinct transaction types from the transaction_log table
   * @returns Observable<string[]> list of transaction type values
   */
  getTransactionTypeList(): Observable<string[]> {
    const url = `${environment.backOfficeUrl}${serviceUris.getTransactionTypes}`;
    return this.http.get<TransactionTypeListResponse>(url).pipe(map((response) => response.data || []));
  }
}
